import { createSelector } from 'reselect';

const selectGlobalEANs = (state: any) => state.globalEANs;

export const selectGlobalEANsCurrentItem = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.current);

export const selectGlobalEANsListItems = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.list);

export const selectGlobalEANsItemById = (itemId: any) =>
    createSelector(selectGlobalEANsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalEANsQueryItems = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.query);

export const selectGlobalEANsCreatedItem = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.create);

export const selectGlobalEANsUpdatedItem = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.update);

export const selectGlobalEANsReadItem = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.read);

export const selectGlobalEANsDeletedItem = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.delete);

export const selectGlobalEANsSearchedItems = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.search);

export const selectGlobalEANsItemsCount = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.count);

export const selectGlobalEANsItemsFilter = createSelector([selectGlobalEANs], (globalEANs) => globalEANs.filter);